import { createThreadBehaviour } from './shared-responder-v2-core-thread-behaviour';
import {
  emptyTaskDraft,
  reduceTaskDraft,
} from './shared-responder-v2-core-thread-task';
import { THREAD_KINDS } from './shared-responder-v2-core-thread.consts';

export const MOBILE_APP_THREAD_BEHAVIOUR = createThreadBehaviour({
  kind: THREAD_KINDS.MobileApp,
  isAnswerEditable: false,
  emptyDraft: emptyTaskDraft,
  reduceDraft: reduceTaskDraft,
  isDraftComplete: () => true,
  showsContinueButton: () => true,
  recordsVoiceWhenUrlPresent: true,
});
